var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticStyle: { "margin-top": "16px", "padding-top": "10px" } },
    [
      _c(
        "el-table",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.dataListLoading,
              expression: "dataListLoading",
            },
          ],
          staticClass: "table-content",
          attrs: {
            data: _vm.tableData,
            height: _vm.tableHeight,
            "header-cell-style": this.$globalGrayTableHeaderStyle,
            stripe: "",
            border: "",
          },
        },
        [
          _c("el-table-column", {
            attrs: {
              index: _vm.indexMethod,
              align: "center",
              label: "序号",
              type: "index",
              width: "50",
              "show-overflow-tooltip": true,
              fixed: "left",
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "审核状态",
              prop: "receiveStatusName",
              "header-align": "center",
              align: "left",
              "min-width": "110",
              "show-overflow-tooltip": true,
            },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function (scope) {
                  return [
                    _c(
                      "el-popover",
                      {
                        ref: `popover-${scope.$index}`,
                        attrs: {
                          placement: "bottom",
                          width: "200",
                          trigger: "click",
                        },
                      },
                      [
                        _c(
                          "span",
                          {
                            staticStyle: {
                              cursor: "pointer",
                              "margin-top": "10px",
                            },
                            style: {
                              color:
                                _vm.checkReceiveStatus.length > 0
                                  ? "#1890ff"
                                  : "",
                            },
                            attrs: { slot: "reference" },
                            slot: "reference",
                          },
                          [
                            _vm._v(" 审核状态 "),
                            _c("img", {
                              attrs: {
                                src: require("../../../../../assets/img/shaixuan.png"),
                                alt: "",
                              },
                            }),
                          ]
                        ),
                        _c("div", [
                          _c(
                            "div",
                            { attrs: { id: "el-checkbox-group" } },
                            [
                              _c(
                                "el-checkbox-group",
                                {
                                  model: {
                                    value: _vm.checkReceiveStatus,
                                    callback: function ($$v) {
                                      _vm.checkReceiveStatus = $$v
                                    },
                                    expression: "checkReceiveStatus",
                                  },
                                },
                                _vm._l(
                                  _vm.processingStateList,
                                  function (item, index) {
                                    return _c(
                                      "el-checkbox",
                                      {
                                        key: index,
                                        staticClass: "check_box",
                                        attrs: { label: item.value },
                                      },
                                      [_vm._v(_vm._s(item.label))]
                                    )
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "right",
                                margin: "10px",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", size: "mini" },
                                  on: { click: _vm.getDataList },
                                },
                                [_vm._v("筛选")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", plain: "" },
                                  on: { click: _vm.cancelReceive },
                                },
                                [_vm._v("重置")]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                  ]
                },
              },
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c("i", {
                      class: _vm.formatterStatusClass(scope.row.historyid),
                    }),
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.formatterStatusText(scope.row.historyid))
                      ),
                    ]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "投诉编号",
              prop: "complaintCode",
              "header-align": "center",
              align: "center",
              "min-width": "150",
              "show-overflow-tooltip": true,
            },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function (scope) {
                  return [
                    _c(
                      "el-popover",
                      {
                        attrs: {
                          placement: "bottom",
                          trigger: "click",
                          width: "200",
                        },
                      },
                      [
                        _c(
                          "p",
                          {
                            staticStyle: {
                              cursor: "pointer",
                              "margin-top": "10px",
                            },
                            attrs: { slot: "reference" },
                            slot: "reference",
                          },
                          [
                            _vm._v(" 投诉编号 "),
                            _c("i", { staticClass: "el-icon-search" }),
                          ]
                        ),
                        _c("div", [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "inline-block",
                                padding: "12px",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  placeholder: "请输入投诉编号",
                                },
                                model: {
                                  value: _vm.complaintCodeSearch,
                                  callback: function ($$v) {
                                    _vm.complaintCodeSearch = $$v
                                  },
                                  expression: "complaintCodeSearch",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "right",
                                margin: "10px",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { plain: "", size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      {
                                        _vm.complaintCodeSearch = ""
                                        _vm.getDataList()
                                      }
                                    },
                                  },
                                },
                                [_vm._v("重置")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "primary" },
                                  on: { click: _vm.getDataList },
                                },
                                [_vm._v("搜索")]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "项目(标段)名称",
              prop: "bidSectionName",
              "header-align": "left",
              "min-width": "200",
              "show-overflow-tooltip": true,
            },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function (scope) {
                  return [
                    _c(
                      "el-popover",
                      {
                        attrs: {
                          placement: "bottom",
                          trigger: "click",
                          width: "220",
                        },
                      },
                      [
                        _c(
                          "p",
                          {
                            staticStyle: {
                              cursor: "pointer",
                              "margin-top": "10px",
                            },
                            attrs: { slot: "reference" },
                            slot: "reference",
                          },
                          [
                            _vm._v(" 项目(标段)名称 "),
                            _c("i", { staticClass: "el-icon-search" }),
                          ]
                        ),
                        _c("div", [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "inline-block",
                                padding: "12px",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  placeholder: "请输入项目(标段)名称",
                                },
                                model: {
                                  value: _vm.bidSectionNameSearch,
                                  callback: function ($$v) {
                                    _vm.bidSectionNameSearch = $$v
                                  },
                                  expression: "bidSectionNameSearch",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "right",
                                margin: "10px",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { plain: "", size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      {
                                        _vm.bidSectionNameSearch = ""
                                        _vm.getDataList()
                                      }
                                    },
                                  },
                                },
                                [_vm._v("重置")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "primary" },
                                  on: { click: _vm.getDataList },
                                },
                                [_vm._v("搜索")]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "项目(标段)编号",
              prop: "bidSectionCode",
              align: "center",
              "header-align": "center",
              "min-width": "230",
              "show-overflow-tooltip": true,
            },
            scopedSlots: _vm._u([
              {
                key: "header",
                fn: function (scope) {
                  return [
                    _c(
                      "el-popover",
                      {
                        attrs: {
                          placement: "bottom",
                          trigger: "click",
                          width: "220",
                        },
                      },
                      [
                        _c(
                          "p",
                          {
                            staticStyle: {
                              cursor: "pointer",
                              "margin-top": "10px",
                            },
                            attrs: { slot: "reference" },
                            slot: "reference",
                          },
                          [
                            _vm._v(" 项目(标段)编号 "),
                            _c("i", { staticClass: "el-icon-search" }),
                          ]
                        ),
                        _c("div", [
                          _c(
                            "div",
                            {
                              staticStyle: {
                                display: "inline-block",
                                padding: "12px",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  placeholder: "请输入项目(标段)编号",
                                },
                                model: {
                                  value: _vm.bidSectionCodeSearch,
                                  callback: function ($$v) {
                                    _vm.bidSectionCodeSearch = $$v
                                  },
                                  expression: "bidSectionCodeSearch",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "div",
                            {
                              staticStyle: {
                                "text-align": "right",
                                margin: "10px",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { plain: "", size: "mini" },
                                  on: {
                                    click: function ($event) {
                                      {
                                        _vm.bidSectionCodeSearch = ""
                                        _vm.getDataList()
                                      }
                                    },
                                  },
                                },
                                [_vm._v("重置")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "mini", type: "primary" },
                                  on: { click: _vm.getDataList },
                                },
                                [_vm._v("搜索")]
                              ),
                            ],
                            1
                          ),
                        ]),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              label: "投诉人员",
              prop: "complainter",
              align: "center",
              "header-align": "center",
              "min-width": "120",
              "show-overflow-tooltip": true,
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "整体处理进度",
              prop: "progress",
              align: "left",
              "min-width": "460",
              "show-overflow-tooltip": true,
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "投诉撤回申请人",
              prop: "quashUser",
              "header-align": "left",
              "min-width": "160",
              "show-overflow-tooltip": true,
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "撤回投诉申请时间",
              prop: "createTime",
              "header-align": "center",
              align: "center",
              "min-width": "180",
              "show-overflow-tooltip": true,
            },
          }),
          _c("el-table-column", {
            attrs: {
              label: "操作",
              align: "center",
              fixed: "right",
              "min-width": "60",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function (scope) {
                  return [
                    _c(
                      "el-button",
                      {
                        attrs: { type: "text", size: "small", title: "查看" },
                        on: {
                          click: function ($event) {
                            return _vm.getDetail(scope.row)
                          },
                        },
                      },
                      [_vm._v("查看")]
                    ),
                  ]
                },
              },
            ]),
          }),
        ],
        1
      ),
      _c("el-pagination", {
        attrs: {
          background: "",
          layout: "total, prev, pager, next",
          "page-size": _vm.pageSize,
          total: _vm.total,
          "current-page": _vm.pageIndex,
        },
        on: {
          "size-change": _vm.sizeChangeHandle,
          "current-change": _vm.currentChangeHandle,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }